import React, { useEffect } from "react";
import USPItems from "../Components/USPItems";

const USPContainer = ({ items }) => <USPItems items={items} />;

export default USPContainer;
